/** @format */

import { AuthContext } from "../contexts/auth/AuthContext";
import { useContext } from "react";

export const useAuth = () => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error("useAuth must be used within the AuthProvider component");
	}
	return context;
};
